import React from 'react';
import styled from 'styled-components';
import { media } from '@payright/web-components';

const SCFormSection = styled.section`

  h4 {
    color: ${(props) => props.theme.colours.blue.base};
  }

  .section-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2.46rem 1rem;
    padding-top: 2.46rem;
  }

  ${media.min.medium} {
    .section-content {
      grid-template-columns: 1fr 1fr;
    }

    .left, .right {
      grid-column: auto;
    }

    * {
      grid-column: 1 / 3
    }
  }
`;

type FormSectionProps = {
  title?: string;
  children?: React.ReactNode;
};

export const FormVerticalSection = ({ title, children }: FormSectionProps) => {
  return (
    <SCFormSection className="form-section">
      {title && <h4>{title}</h4>}
      <div className="section-content">{children}</div>
    </SCFormSection>
  );
};

